import React, { useEffect, useContext, useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody, PanelFooter } from './../../components/panel/panel.jsx';
import Chart from 'chart.js/auto';
import jsVectorMap from 'jsvectormap';
import 'jsvectormap/dist/maps/world.js';
import 'jsvectormap/dist/jsvectormap.min.css';
import Calendar from 'react-calendar';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ApexChart from 'react-apexcharts';
import 'react-calendar/dist/Calendar.css';
import axios from 'axios';
import {API_BASE_URL} from "../../apiConfig.jsx";
import {strEncode,strDecode} from '../../encrpt';

import DataTable from 'react-data-table-component';

function DashboardV1() {
	const navigate = useNavigate();
	const [data, setData] = useState([]);
	const [bedata, setBudgetExecutionData] = useState([]);
	const [brtdata, setBeneficiaryReachTargetData] = useState([]);
	const [tacdata, settimelinessactivitydelayData] = useState([]);


    const [pr, setPR] = useState([]);
	const [pre, setPRE] = useState([]);
	const [prs, setPRS] = useState([]);
	const [dd, setDisbursement] = useState([]);
    const [bardata, setBarGraphData] = useState([]);
	const [modalheading, setModalHeading] = useState(null);	
	const [indiid, setModalId] = useState(null);	
	const [selectedUser, setSelectedUser] = useState(null);	
	const [modalData, setModalData] = useState([]);
	const [columns, setColumns] = useState([]);
	const [tabledata, settableData] = useState([]);
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");
        //console.log("authToken",authToken)
		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);

	useEffect(() => {

         axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_participants_registration'),  cols : strEncode ("Count(*) as tot")},
		    { headers: { 'Content-Type': 'application/json' } }) 
				.then( (res) => {             
				setPR(res.data);
			}).catch( (error) => { console.log(error); }); 
		
         axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_participants_evaluation'),  cols : strEncode ("Count(*) as tot")},
		    { headers: { 'Content-Type': 'application/json' } }) 
				.then( (res) => {
					//console.log("res",res.data)
					setPRE(res.data);
				}).catch( (error) => { console.log(error); }); 

	     axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_individual_finance_dashboard_data'),  cols : strEncode ("*") },
		    { headers: { 'Content-Type': 'application/json' } }) 
				.then( (res) => {
					//console.log("res",res.data)
					//setPRS(res.data);
					setDisbursement(res.data);
				}).catch( (error) => { console.log(error); }); 


	   axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_project_budget'),  cols : strEncode ("Count(*) as tot"),  whrc : strEncode ("n_participant_id > 0")},
		    { headers: { 'Content-Type': 'application/json' } }) 
				.then( (res) => {
					//console.log("res",res.data)
					setPRS(res.data);
				}).catch( (error) => { console.log(error); }); 
			

				axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_dashboard_chart_data'),  cols : strEncode ("*")},
		    { headers: { 'Content-Type': 'application/json' } }) 
				.then( (res) => {
					//console.log("res",res.data)
					setBarGraphData(res.data);
				}).catch( (error) => { console.log(error); }); 
          }, []);

	var redColor = (getComputedStyle(document.body).getPropertyValue('--bs-red')).trim();
	var orangeColor = (getComputedStyle(document.body).getPropertyValue('--bs-orange')).trim();
	var tealColor = (getComputedStyle(document.body).getPropertyValue('--bs-teal')).trim();
	var blueColor = (getComputedStyle(document.body).getPropertyValue('--bs-blue')).trim();
	var gray500Color = (getComputedStyle(document.body).getPropertyValue('--bs-gray-500')).trim();
	var componentColor = (getComputedStyle(document.body).getPropertyValue('--bs-component-color')).trim();
	var red = (getComputedStyle(document.body).getPropertyValue('--bs-red')).trim();
	var orange = (getComputedStyle(document.body).getPropertyValue('--bs-orange')).trim();
	var lime = (getComputedStyle(document.body).getPropertyValue('--bs-lime')).trim();
	var sparkLineOptions = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [redColor]
	};
	var sparkLineOptions2 = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [orangeColor]
	};
	var sparkLineOptions3 = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [tealColor]
	};
	var sparkLineOptions4 = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [blueColor]
	};
	var sparkLineOptions5 = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [gray500Color]
	};
	var sparkLineOptions6 = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [componentColor]
	};
	
	var sparklineData = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	var sparklineData2 = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	var sparklineData3 = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	var sparklineData4 = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	var sparklineData5 = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	var sparklineData6 = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	
	var date = new Date();
	
	var conversionRateChartOptions = {
		chart: {
			type: 'line',
			width: 160,
			height: 28,
			sparkline: { enabled: true }
		},
		stroke: { curve: 'smooth', width: 3 },
		fill: {
			type: 'gradient',
			gradient: {
				opacityFrom: 1,
				opacityTo: 1,
				colorStops: [
				{ offset: 0, color: red, opacity: 1 },
				{ offset: 50, color: orange, opacity: 1 },
				{ offset: 100, color: lime, opacity: 1 }]
			},
		},
		labels: ['Jun 23', 'Jun 24', 'Jun 25', 'Jun 26', 'Jun 27', 'Jun 28', 'Jun 29'],
		xaxis: { crosshairs: { width: 1 } },
		tooltip: {
			theme: 'dark',
			fixed: { enabled: false },
			x: { show: false },
			y: {
				title: { formatter: function (seriesName) { return '' } },
				formatter: (value) => { return value + '%' },
			},
			marker: { show: false }
		},
		responsive: [
			{ breakpoint: 3000, options: { chart: { width: 120 } } },
			{ breakpoint: 1300, options: { chart: { width: 100 } } },
			{ breakpoint: 1200, options: { chart: { width: 160 } } },
			{ breakpoint: 900, options: { chart: { width: 120 } } },
			{ breakpoint: 576, options: { chart: { width: 180 } } },
			{ breakpoint: 400, options: { chart: { width: 120 } } }
		]
	};
	var conversionRateChartSeries = [{
		data: [2.68, 2.93, 2.04, 1.61, 1.88, 1.62, 2.80]
	}];

	var chart;

	var chart1;
	
	function renderChart() {
		console.log("bargrph",bardata)
		var teal = (getComputedStyle(document.body).getPropertyValue('--bs-teal')).trim();
		var tealRgb = (getComputedStyle(document.body).getPropertyValue('--bs-teal-rgb')).trim();
		var blue = (getComputedStyle(document.body).getPropertyValue('--bs-blue')).trim();
		var blueRgb = (getComputedStyle(document.body).getPropertyValue('--bs-blue-rgb')).trim();
		
		
		var orange = (getComputedStyle(document.body).getPropertyValue('--bs-orange')).trim();
		var orangeRgb = (getComputedStyle(document.body).getPropertyValue('--bs-orange-rgb')).trim();
		var red = (getComputedStyle(document.body).getPropertyValue('--bs-red')).trim();
		var redRgb = (getComputedStyle(document.body).getPropertyValue('--bs-red-rgb')).trim();
		
		
		var componentBg = (getComputedStyle(document.body).getPropertyValue('--bs-component-bg')).trim();
		
		var bodyFontFamily = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-family')).trim();
		var bodyFontWeight = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight')).trim();
		var bodyColor = (getComputedStyle(document.body).getPropertyValue('--bs-body-color')).trim();
		var borderColor = (getComputedStyle(document.body).getPropertyValue('--bs-border-color')).trim();
		
		Chart.defaults.font.family = bodyFontFamily;
		Chart.defaults.font.size = 12;
		Chart.defaults.color = bodyColor;
		Chart.defaults.borderColor = borderColor;
		Chart.defaults.plugins.legend.display = true;
		Chart.defaults.plugins.tooltip.padding = { left: 8, right: 12, top: 8, bottom: 8 };
		Chart.defaults.plugins.tooltip.cornerRadius = 8;
		Chart.defaults.plugins.tooltip.titleMarginBottom = 6;
		Chart.defaults.plugins.tooltip.titleFont.family = bodyFontFamily;
		Chart.defaults.plugins.tooltip.titleFont.weight = bodyFontWeight;
		Chart.defaults.plugins.tooltip.footerFont.family = bodyFontFamily;
		Chart.defaults.plugins.tooltip.displayColors = true;
		Chart.defaults.plugins.tooltip.boxPadding = 6;
		Chart.defaults.scale.grid.color = borderColor;
		Chart.defaults.scale.beginAtZero = true;
		Chart.defaults.maintainAspectRatio = false;

		// Extract labels and datasets from bardata
			const labels = bardata.map(item => item.org);
			console.log("bardata",bardata)			
			const registrationData = bardata.map(item => item.tot_register);
			const evaluationData = bardata.map(item => item.tot_evaluate);
			const InitiativeData = bardata.map(item => item.tot_initiatives);
			const financeData = bardata.map(item => item.tot_finance);
		
		var chart1Container = document.getElementById('chart-1');
		if (chart1) {
			chart1.destroy();
		}
		if (chart1Container) {
			chart1Container.innerHTML = '<canvas id="lineChart"></canvas>';
			chart1 = new Chart(document.getElementById('lineChart'), {
				type: 'bar', 
				data: {
					labels: labels,
					datasets: [{
						label: 'تسجيل المشاركين',
						fill: false,
						lineTension: 0.1,
						backgroundColor: 'rgba('+ tealRgb +', 0.25)',
						borderColor: teal,
						borderWidth: 2,
						pointBorderColor: teal,
						pointBackgroundColor: componentBg,
						pointBorderWidth: 2,
						pointHoverRadius: 5,
						pointHoverBackgroundColor: componentBg,
						pointHoverBorderColor: teal,
						pointHoverBorderWidth: 3,
						pointRadius: 3,
						pointHitRadius: 10,
						data: registrationData
					},{
						label: 'تقييم',
						fill: false,
						lineTension: 0.1,
						backgroundColor: 'rgba('+ orangeRgb +', 0.25)',
						borderColor: orange,
						borderWidth: 2,
						pointBorderColor: orange,
						pointBackgroundColor: componentBg,
						pointBorderWidth: 2,
						pointHoverRadius: 5,
						pointHoverBackgroundColor: componentBg,
						pointHoverBorderColor: orange,
						pointHoverBorderWidth: 3,
						pointRadius: 3,
						pointHitRadius: 10,
						data: evaluationData
					},{
						label: 'المبادرات',
						fill: false,
						lineTension: 0.1,
						backgroundColor: 'rgba('+ blueRgb +', 0.25)',
						borderColor: blue,
						borderWidth: 2,
						pointBorderColor: blue,
						pointBackgroundColor: componentBg,
						pointBorderWidth: 2,
						pointHoverRadius: 5,
						pointHoverBackgroundColor: componentBg,
						pointHoverBorderColor: blue,
						pointHoverBorderWidth: 3,
						pointRadius: 3,
						pointHitRadius: 10,
						data: InitiativeData
					}
				   ,{
						label: 'تمويل',
						fill: false,
						lineTension: 0.1,
						backgroundColor: 'rgba('+ redRgb +', 0.25)',
						borderColor: red,
						borderWidth: 2,
						pointBorderColor: red,
						pointBackgroundColor: componentBg,
						pointBorderWidth: 2,
						pointHoverRadius: 5,
						pointHoverBackgroundColor: componentBg,
						pointHoverBorderColor: red,
						pointHoverBorderWidth: 3,
						pointRadius: 3,
						pointHitRadius: 10,
						data: financeData
					},
				]
				}
			});
		}
	}
	
	function renderMap() {
		var componentActiveBg = (getComputedStyle(document.body).getPropertyValue('--bs-component-active-bg')).trim();
		var gray500 = (getComputedStyle(document.body).getPropertyValue('--bs-gray-500')).trim();
		var bodyColor = (getComputedStyle(document.body).getPropertyValue('--bs-body-color')).trim();
		var bodyFontFamily = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-family')).trim();
		const map = document.getElementById('jvectorMap');
		const mapElm = document.querySelectorAll('.jvm-tooltip');
		
		if (map) {
			for (let i = 0; i < mapElm.length; i++) {
				mapElm[i].remove();
			}
			map.innerHTML = '';
		
			var markers = [
				{ name: "Baghdad", coords: [33.312805,44.361488] },
			
			];
			new jsVectorMap({
				selector: '#jvectorMap',
				map: 'world',
				zoomButtons: true,
				normalizeFunction: 'polynomial',
				hoverOpacity: 0.5,
				hoverColor: false,
				zoomOnScroll: false,
				focusOn: {
					 region: 'IQ',
 						 scale: 9           // zoom level
				},
				series: {
					regions: [{
						normalizeFunction: 'polynomial'
					}]
				},
				labels: {
					markers: {
						render: (marker) => marker.name
					}
				},
				
				markers: markers,
				markerStyle: {
					initial: {
						fill: componentActiveBg,
						stroke: 'none',
						r: 5,
					},
					hover: {
						fill: componentActiveBg
					}
				},
				markerLabelStyle: {
					initial: {
						fontFamily: bodyFontFamily,
						fontSize: '12px',
						fill: bodyColor
					},
				},
				regionStyle: {
					initial: {
						fill: gray500,
						fillOpacity: 0.5,
						stroke: 'none',
						strokeWidth: 0.4,
						strokeOpacity: 1
					},
					hover: {
						fillOpacity: 0.5
					}
				},
				backgroundColor: 'transparent',
			});
		}
	}
	const handleModalOpen = async (user,table,modaltitle) => {
		//console.log("user.id",user.id)
		setSelectedUser(user);	
		setModalId(user.id)
		setModalHeading(modaltitle)
		axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode(table),cols:strEncode('activités as `activités`, Valeurintermédiaire  as  `Valeurintermédiaire`,Valeurcible as `Valeurcible`,Réalisation as `Réalisation`, Date(latest_entry) as `Date de déclaration`') },{ headers: { 'Content-Type': 'application/json' } }) 
		.then( (res) => {					
		  if (!res.data || !res.data || res.data.length === 0) {
			  console.warn("Warning: API returned an empty or undefined response.");
			  setColumns([]); // Reset columns
			  settableData([]); // Reset table data
			  return;
		  }
		  const columnKeys = Object.keys(res.data[0]);
		  
		  const formattedColumns = columnKeys.map((key) => ({
			  name: key.charAt(0).toUpperCase() + key.slice(1),
			  selector: row => row[key],
			  sortable: true,
			  cell: row => row[key] // Show normal column data
			}));			
		  //console.log("columnKeys",columnKeys)
		  setColumns(formattedColumns);
		  settableData(res.data);					
		}).catch(error => {
		  console.error("API Error:", error);
		});
	  
	  };

	  useEffect(() => {
			if (bardata && bardata.length > 0) {
				renderChart(bardata);
			}
         }, [bardata]);
	


	useEffect(() => {
    // eslint-diable-next-line
        renderMap();
		if (bardata && bardata.length > 0) {
			renderChart(bardata);
		}	
		
		document.addEventListener('theme-reload', () => {
			renderMap();
			if (bardata && bardata.length > 0) {
			renderChart(bardata);
		}
		});
		
		// eslint-disable-next-line
	}, []);
	
	const closeModal = () => {
		setModalData([]);
	   }
	
	return (
		<>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v1">الرئيسية</Link></li>
				<li className="breadcrumb-item active">لوحة المعلومات</li>
			</ol>
			<h1 className="page-header">مشروع شباب ماسول</h1>
			
				<div className="row">
								
				{dd.map((item) => (
				<div className="col-xl-3 col-md-6">
					<div className="widget widget-stats bg-red">
						<div className="stats-icon stats-icon-lg"><i className="fa fa-dollar-sign fa-fw"></i></div>
						<div className="stats-content">
							<div className="stats-title" style={{fontSize:"30px"}}>تم الانتهاء من الصرف</div>
							<div className="stats-number">{item.total_count}</div>
							<div className="stats-progress progress">
								<div className="progress-bar" style={{ width: `${(item.total_count / 2000) * 100}%` }}
></div>
							</div>
							<div className="stats-desc">الدفعة الأولى فقط ({item.first_payment_count}) / كلا المدفوعات ({item.both_payments_count})</div>
						</div>
					</div>
				</div>
				))}

				{ prs.map((item) => (
				<div className="col-xl-3 col-md-6">
					<div className="widget widget-stats bg-indigo">
						<div className="stats-icon stats-icon-lg"><i className="fa fa-archive fa-fw"></i></div>
						<div className="stats-content">
							<div className="stats-title" style={{fontSize:"25px"}}>أكمل المشارك المهارات الشخصية</div>
							<div className="stats-number">{item.tot}</div>
							<div className="stats-progress progress">
								<div className="progress-bar" style={{ width: `${(item.tot / 2000) * 100}%` }}
></div>
							</div>
							<div className="stats-desc"></div>
						</div>
					</div>
				</div>
				)) }

				
					{pre.map((item) => (
				<div className="col-xl-3 col-md-6">
					<div className="widget widget-stats bg-blue">
						<div className="stats-icon stats-icon-lg"><i className="fa fa-comment-alt fa-fw"></i></div>
						<div className="stats-content">
							<div className="stats-title" style={{fontSize:"30px"}}>المشارك مع التقييم المكتمل</div>
							<div className="stats-number">{item.tot}</div>
							<div className="stats-progress progress">
								<div className="progress-bar" style={{ width: `${(item.tot / 2000) * 100}%` }}></div>
							</div>
							<div className="stats-desc"></div>
						</div>
					</div>
				</div>
				   ))}

				{pr.map((item) => (
				<div className="col-xl-3 col-md-6">
					<div className="widget widget-stats bg-teal">
						<div className="stats-icon stats-icon-lg"><i className="fa fa-globe fa-fw"></i></div>
						<div className="stats-content">
							<div className="stats-title" style={{fontSize:"30px"}}>المشاركون المسجلون</div>
							<div className="stats-number">{item.tot}</div>
							<div className="stats-progress progress">
								<div className="progress-bar" style={{ width: `${(item.tot / 2000) * 100}%` }}></div>
							</div>
							<div className="stats-desc"></div>
						</div>
					</div>
				</div>
                    ))}

			</div>
						<div className="row">
				<div className="col-xl-6">
					<Panel>
						<PanelHeader>حالة الأفراد المسجلين حسب المنظمة</PanelHeader>
						<PanelBody>
							<div id="chart-1" className="h-300px"></div>
						</PanelBody>
					</Panel>
			
				</div>
				<div className="col-xl-6">
					<Panel>
						<PanelHeader noButton={true}>
						أصل الزوار
						</PanelHeader>
						<div style={{height: '350px'}}>
							<div id="jvectorMap" style={{height: '350px'}}></div>
						</div>
						
					</Panel>
				</div>
			</div>

			<div className="modal modal-pos fade" id="modalPosBooking">
				<div className="modal-dialog modal-lg" style={{maxWidth:"95%"}}>
					<div className="modal-content border-0">
						<div>
							<div className="p-0">
														
    <div className="modal-body">
        <div className="d-flex align-items-center mb-3">
            <h4 className="modal-title d-flex align-items-center">
                <i className="fa fa-bowl-rice fs-2 me-2 my-n1"></i> {modalheading}
            </h4>
            <a href="/#" data-bs-dismiss="modal" onClick={closeModal} className="ms-auto btn-close">&nbsp;</a>
        </div>
        <div className="row">
            <div className="row mb-15px">
                                                  <DataTable
									title=""
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>
               
            </div>
        </div>
    </div>
    <div className="modal-footer">									
       
    </div>



							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
};

export default DashboardV1;